import React from 'react';
import {
  HeadingD,
  ProductContent,
} from 'DesignSystem/Typography';

const AnswerQuestionTooltipContent = () => (
  <div
    className="recipient-preview-tour-tooltip-content recipient-preview-answer-question-tooltip"
  >
    <HeadingD className="recipient-preview-answer-question-tooltip-heading">
      The fillable field you’ve created is now in a questionnaire format for recipients!
    </HeadingD>
    <ProductContent
      className="recipient-preview-answer-question-tooltip-text"
      variation="small"
    >
      Try answering as a recipient.
    </ProductContent>
  </div>
);

export default AnswerQuestionTooltipContent;



// WEBPACK FOOTER //
// ./src-react/SelfServeRecipientBuilder/components/AnswerQuestionTooltipContent.jsx